// The one error shape every surface returns: { error: { code, message, details? } }.
// A new code goes here AND into docs/openapi.json; openapi-sync.test.ts keeps them equal.
import { z } from "zod";

export const ErrorCode = z.enum([
  "unauthenticated",
  "token_expired",
  "ip_not_whitelisted",
  "forbidden",
  "feature_read_only",
  "totp_required",
  "step_up_required",
  "not_found",
  "email_in_use",
  "validation_failed",
  "malformed_body",
  "payload_too_large",
  "insufficient_funds",
  "domain_unavailable",
  "order_in_progress",
  "domain_locked",
  "price_changed",
  "zone_unmanaged",
  "tld_not_supported",
  "tld_exists",
  "tld_unpriced",
  "price_below_wholesale",
  "term_not_offered",
  "application_incomplete",
  "application_decided",
  "reseller_not_active",
  "reseller_not_suspended",
  "deactivation_blocked",
  "team_full",
  "rate_limited",
  "registry_unavailable",
  "internal",
]);
export type ErrorCode = z.infer<typeof ErrorCode>;

export const ErrorDetail = z.object({
  path: z.string().optional(),
  row: z.int().positive().optional(),
  message: z.string(),
});
export type ErrorDetail = z.infer<typeof ErrorDetail>;

export const ErrorBody = z.object({
  error: z.object({
    code: ErrorCode,
    message: z.string(),
    details: z.array(ErrorDetail).optional(),
  }),
});
export type ErrorBody = z.infer<typeof ErrorBody>;
